import { createRouter, createWebHistory } from 'vue-router'
import Login from '../../components/Login'
import Logout from '../../components/Logout'
import Signup from '../../components/Signup'
import Dashboard from '../../components/Dashboard'
import Transmitters from '../../components/Transmitters'
import WaterMeters from '../../components/WaterMeters'
import ElectricityMeters from '../../components/ElectricityMeters'
import Homebases from '../../components/Homebases'
import Create from '../../components/Create'
import CheckDevice from '../../components/CheckDevice'
import OpenValve from '../../components/OpenValve.vue'
import Alarms from '../../components/Alarms'
import Disbursement from '../../components/Disbursement'
import ResetPassword from '../../components/ResetPassword'
import Valves from '../../components/Valves'

import store, {ORGANIZATION_REQUEST} from '../../_store'
import GasMeters from '../../components/GasMeters.vue'
import HeatMeters from '../../components/HeatMeters.vue'

let organizationsLoadPromise = null

const ensureOrganizationsLoaded = () => {
    if (!store.getters.isAuthenticated) {
        return Promise.resolve()
    }
    const organizations = store.getters.availableOrganizations
    if (Array.isArray(organizations)) {
        return Promise.resolve()
    }
    if (organizationsLoadPromise) {
        return organizationsLoadPromise
    }
    organizationsLoadPromise = store.dispatch(ORGANIZATION_REQUEST, {
        action: 'read',
        current: false
    }).then(() => {}).catch(() => {}).then(() => {
        organizationsLoadPromise = null
    })
    return organizationsLoadPromise
}

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/login')
}

const ifOrganization = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next('/login')
        return
    }
    ensureOrganizationsLoaded().then(() => {
        if (store.getters.hasOrganization) {
            next()
            return
        }
        next('/create')
    })
}

const ifNotOrganization = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next('/login')
        return
    }
    ensureOrganizationsLoaded().then(() => {
        if (!store.getters.hasOrganization) {
            next()
            return
        }
        next('/')
    })
}

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: Dashboard,
            beforeEnter: ifOrganization
        },
        {
            path: '/transmitters',
            component: Transmitters,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/water-meters',
            component: WaterMeters,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/electricity-meters',
            component: ElectricityMeters,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/gas-meters',
            component: GasMeters,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/heat-meters',
            component: HeatMeters,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/homebases',
            component: Homebases,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/valves',
            component: Valves,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/alarms',
            component: Alarms,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/signup',
            component: Signup,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/create',
            component: Create,
            beforeEnter: ifNotOrganization
        },
        {
            path: '/logout',
            component: Logout,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/split-bill',
            component: Disbursement,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/kontrola',
            component: CheckDevice
        },
        {
            path: '/open',
            component: OpenValve
        },
        {
            path: '/reset-password',
            component: ResetPassword
        }
    ]
})

export default router
